import PropTypes from "prop-types";
import React from "react";
import { Form, TextArea, Grid } from "semantic-ui-react";

import { DollarField } from "../../../../../../../../../../../../components/CustomFormElements";
import { displayAndBorrowerFeeType } from "../../../../../../../../../../../../services/Constants/additionalFeeOptions";

function DisplayOnlyForm({ updateValues, fee }) {
  return (
    <>
      <strong>Display Only Fee</strong> <br />
      <Grid>
        <Grid.Row columns="3">
          <Grid.Column>
            <DollarField
              label="Fee Amount"
              name="fee_amount"
              onChange={updateValues}
              value={fee.fee_amount}
            />
          </Grid.Column>
          <Grid.Column>
            <Form.Dropdown
              data-testid="fee-reason-select"
              label="Fee Reason"
              selection
              name="display_only_reason"
              options={displayAndBorrowerFeeType}
              value={fee.display_only_reason || ""}
              onChange={(ev, data) => updateValues(data)}
            />
          </Grid.Column>
          {fee.display_only_reason === "Other" && (
            <Grid.Column>
              <Form.Input
                data-testid="fee-reason-other-input"
                label="Other Reason"
                name="display_only_reason_other"
                value={fee.display_only_reason_other || ""}
                onChange={(ev, data) => updateValues(data)}
                maxLength="250"
                disabled={!fee.display_only_reason}
                required
              />
            </Grid.Column>
          )}
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <b>Description</b>
            <TextArea
              data-testid="fee-description-input"
              name="description"
              value={fee.description || ""}
              onChange={(e, data) => updateValues(data)}
              maxLength="250"
              placeholder="Max length 250"
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
}

DisplayOnlyForm.propTypes = {
  fee: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
  ).isRequired,
  updateValues: PropTypes.func.isRequired
};

export default DisplayOnlyForm;
